/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WriteOffMissingResultItemDto = {
  discrepancyId: number;
  status: WriteOffMissingResultItemDto.status;
  message?: string;
};
export namespace WriteOffMissingResultItemDto {
  export enum status {
    OK = 'ok',
    SKIPPED = 'skipped',
    ERROR = 'error',
  }
}
